/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.2 ./public/camille.glb --shadows
*/

import React, { forwardRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Html, useGLTF, useScroll } from "@react-three/drei";
import useRefs from "react-use-refs";

export function Camille(props) {
  const { nodes, materials } = useGLTF("/camille.glb");
  const scroll = useScroll();
  const [camilleRef, left, gravityCenter] = useRefs();

  useFrame(({ mouse, viewport }) => {
    if (camilleRef !== undefined && camilleRef.current !== undefined) {
      const r1 = scroll.range(0, 1 / 4);
      const r2 = scroll.range(1 / 4, 1 / 4);
      const r3 = scroll.range(1 / 2, 1 / 2);

      if (r1 < 0.1) {
        const x = mouse.x * viewport.width;
        const y = mouse.y * viewport.height;
        gravityCenter.current.lookAt(x, y, 100);
      }
      camilleRef.current.scale.x =
        camilleRef.current.scale.y =
        camilleRef.current.scale.z =
          15 - r1 * 8 - r2 - r3 * 3;
      camilleRef.current.rotation.y = -(r1 * 3) - r2 - r3 * 2;
      camilleRef.current.position.y = -27 + r1 * 17 + r2 * 2 + r3 * 5.5;
    }
  });

  return (
    <group position={[0, 0, 0]}>
      <group ref={camilleRef} {...props} dispose={null}>
        <primitive object={nodes.Hips} ref={gravityCenter} />
        <skinnedMesh
          geometry={nodes.Wolf3D_Body.geometry}
          material={materials.Wolf3D_Body}
          skeleton={nodes.Wolf3D_Body.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Wolf3D_Outfit_Bottom.geometry}
          material={materials.Wolf3D_Outfit_Bottom}
          skeleton={nodes.Wolf3D_Outfit_Bottom.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Wolf3D_Outfit_Footwear.geometry}
          material={materials.Wolf3D_Outfit_Footwear}
          skeleton={nodes.Wolf3D_Outfit_Footwear.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Wolf3D_Outfit_Top.geometry}
          material={materials.Wolf3D_Outfit_Top}
          skeleton={nodes.Wolf3D_Outfit_Top.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Wolf3D_Hair.geometry}
          material={materials.Wolf3D_Hair}
          skeleton={nodes.Wolf3D_Hair.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Wolf3D_Glasses.geometry}
          material={materials.Wolf3D_Glasses}
          skeleton={nodes.Wolf3D_Glasses.skeleton}
        />
        <skinnedMesh
          name="EyeLeft"
          geometry={nodes.EyeLeft.geometry}
          material={materials.Wolf3D_Eye}
          skeleton={nodes.EyeLeft.skeleton}
          morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary}
          morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences}
        />
        <skinnedMesh
          name="EyeRight"
          geometry={nodes.EyeRight.geometry}
          material={materials.Wolf3D_Eye}
          skeleton={nodes.EyeRight.skeleton}
          morphTargetDictionary={nodes.EyeRight.morphTargetDictionary}
          morphTargetInfluences={nodes.EyeRight.morphTargetInfluences}
        />
        <skinnedMesh
          name="Wolf3D_Head"
          geometry={nodes.Wolf3D_Head.geometry}
          material={materials.Wolf3D_Skin}
          skeleton={nodes.Wolf3D_Head.skeleton}
          morphTargetDictionary={nodes.Wolf3D_Head.morphTargetDictionary}
          morphTargetInfluences={nodes.Wolf3D_Head.morphTargetInfluences}
        />
        <skinnedMesh
          name="Wolf3D_Teeth"
          geometry={nodes.Wolf3D_Teeth.geometry}
          material={materials.Wolf3D_Teeth}
          skeleton={nodes.Wolf3D_Teeth.skeleton}
          morphTargetDictionary={nodes.Wolf3D_Teeth.morphTargetDictionary}
          morphTargetInfluences={nodes.Wolf3D_Teeth.morphTargetInfluences}
        />
      </group>
      <Tag
        ref={left}
        position={[-5, -92, 0]}
        head="design"
        stat="BY"
        expl={`Camille\nRoy`}
      />
    </group>
  );
}

const Tag = forwardRef(({ head, stat, expl, ...props }, ref) => {
  return (
    <Html ref={ref} className="data" center {...props}>
      <div>{head}</div>
      <h1>{stat}</h1>
      <h2>{expl}</h2>
    </Html>
  );
});

useGLTF.preload("/camille.glb");
